import React from "react";
import { GrClose } from "react-icons/gr";

const FPAlreadyExistsModal = ({ isOpen, onClose, companyName }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-text bg-opacity-50">
            <div className="relative w-full max-w-lg bg-white p-6 rounded-lg shadow-lg mx-4">
                <GrClose
                    className="cursor-pointer absolute top-4 right-4"
                    size="22px"
                    onClick={onClose}
                />

                <h2 className="text-xl font-bold mb-4">FP bereits vorhanden</h2>

                <div className="space-y-4">
                    <p className="text-base">
                        {companyName ? (
                            <><span className="font-semibold">{companyName}</span> ist bereits im PFB Planungskalender vorhanden.</>
                        ) : (
                            <>Dieses FP ist bereits im PFB Planungskalender vorhanden.</>
                        )}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FPAlreadyExistsModal;
